import React, { PureComponent } from 'react'
import { AutoSuggest } from './AutoSuggest'
import moment from 'moment-timezone'

export class TimezonePicker extends PureComponent {
  handleFetch = (text, callback, error) => {
    callback(moment.tz.names().filter(tz => tz.toLowerCase().includes(text.toLowerCase())))
  }

  render = () => {
    let {...props} = this.props
    return (
      <AutoSuggest onSuggestionsFetchRequested={this.handleFetch} {...props}/>
    )
  }
}